export const NFC_STATUS_DISABLED = "disabled";
export const NFC_STATUS_NOT_SUPPORTED = "not_supported";
export const NFC_STATUS_TIMEOUT = "timeout";
export const NFC_STATUS_WRONG_IOS_VERSION = "iosVersion";
export const NFC_STATUS_FAILED = "failed";
export const NFC_STATUS_INTERRUPTED = "interupt";
